import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, fmtMoney } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { FilterPills, DocList } from "@/pages/Quotes";

export default function Invoices() {
  const [f, setF] = useState("all");
  const { data: invoices = [], isLoading } = useQuery({ queryKey: ["invoices"], queryFn: () => api.get("/invoices").then((r) => r.data) });
  const list = invoices.filter((i) => f === "all" || (f === "open" ? !["paid", "draft"].includes(i.status) : i.status === f));
  const outstanding = invoices.filter((i) => !["paid", "draft"].includes(i.status)).reduce((a, i) => a + i.balance_due, 0);
  return (
    <div data-testid="invoices-page">
      <PageHeader title="Invoices" subtitle={`${fmtMoney(outstanding)} outstanding`} />
      <FilterPills testId="invoices-filter" value={f} onChange={setF} options={[["all", "All"], ["draft", "Draft"], ["open", "Open"], ["overdue", "Overdue"], ["partially_paid", "Partial"], ["paid", "Paid"]]} />
      <DocList items={list} to="/invoices" testId="invoices-list" dateKey="issue_date" loading={isLoading} emptyTitle={f === "all" ? "No invoices yet" : "No invoices match this filter"} emptyHint={f === "all" ? "Complete a job and create an invoice from it." : undefined} sub={(i) => `Due ${i.due_date}${i.balance_due > 0 && i.status !== "draft" ? ` | ${fmtMoney(i.balance_due)} remaining` : ""}`} />
    </div>
  );
}
